import React from 'react'

import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import lang from '@/lang'
import { DocumentExportType } from '@/enums/document-export-type'

const allowedDocumentTypes = Object.values(DocumentExportType)

const ContentCell = (props) => {
  const classes = useStyles()
  const { data: { content = [] } = {}, className } = props

  const isDocumentTypeAllowed = content.every(type => allowedDocumentTypes.includes(type))

  const contentItems = content.map((type) => {
    const label = isDocumentTypeAllowed ? lang.documentExport.content.documentTypes[type] : lang.documentExport.content[type]

    return label ? <span key={type}>{label}</span> : null
  })

  return (
    <div className={clsx(classes.container, className)}>
      {contentItems}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    '& span': {
      lineHeight: '20px',
    },
  },
}))

export default ContentCell
